import { createSelector } from "reselect";

import {
  getSundryBusinessIdFromDocument,
  getSuggestedSundryBusinessFieldsFromBillingDocumentAndTemplate,
} from "constants/sundryTemplates";

import { EMPTY_ARRAY, EMPTY_OBJECT } from "lib";

import {
  getBillingDocuments,
  getBusinesses,
  getSundryTemplates,
} from "selectors";

export const selectRelevantSundryTemplatesByBillingDocumentIdLookup =
  createSelector(
    [getSundryTemplates, getBillingDocuments, getBusinesses],
    (sundryTemplates, billingDocuments, businessByIdLookup) =>
      Object.values(billingDocuments).reduce((acc, billingDocument) => {
        acc[billingDocument.id] = Object.values(sundryTemplates)
          .filter(sundryTemplate =>
            [sundryTemplate.paidFromType, sundryTemplate.paidToType].includes(
              billingDocument.type,
            ),
          )
          // hide sundry templates which template set business does not match
          // the suggested business from the billing document.
          .filter(sundryTemplate => {
            const documentBusiness =
              businessByIdLookup[
                getSundryBusinessIdFromDocument(billingDocument)
              ];

            const suggestedBusinessFields =
              getSuggestedSundryBusinessFieldsFromBillingDocumentAndTemplate(
                billingDocument.type,
                sundryTemplate,
                documentBusiness,
              );

            if (
              sundryTemplate.paidFromBusinessId &&
              suggestedBusinessFields.toBusinessId &&
              sundryTemplate.paidFromBusinessId !==
                suggestedBusinessFields.toBusinessId
            ) {
              return false;
            }
            if (
              sundryTemplate.paidToBusinessId &&
              suggestedBusinessFields.fromBusinessId &&
              sundryTemplate.paidToBusinessId !==
                suggestedBusinessFields.fromBusinessId
            ) {
              return false;
            }
            return true;
          });

        return acc;
      }, {}),
  );

export const getRelevantSundryTemplatesByBillingDocumentId =
  billingDocumentId => state =>
    selectRelevantSundryTemplatesByBillingDocumentIdLookup(state)[
      billingDocumentId
    ] || EMPTY_ARRAY;

export const getSundryTemplateById = sundryTemplateId => state =>
  getSundryTemplates(state)[sundryTemplateId] || EMPTY_OBJECT;
